/* PENGUIN v7: cosmetic enhancement only. Never alters orders, prices or reviews. */
(function () {
  'use strict';
  function init(scope) {
    var root = scope.querySelector ? scope.querySelector('#pk6') : null;
    if (!root && scope.id === 'pk6') root = scope;
    if (!root || root.dataset.p7Enhanced === 'true') return;
    root.dataset.p7Enhanced = 'true';
    var disposers = [];
    function dispose() { disposers.forEach(function (fn) { fn(); }); disposers = []; delete root.dataset.p7Enhanced; delete root.__p7Dispose; }
    root.__p7Dispose = dispose;
    window.addEventListener('pagehide', dispose, {once: true});
    disposers.push(function () { window.removeEventListener('pagehide', dispose); });
    // Localized anchor handling is native. Keep preview_theme_id and Shopify history intact.
    root.querySelectorAll('.p7-prose table, .shopify-policy__body table, .p7-main .rte table').forEach(function (table) {
      // Legal disclosure rows are responsive without a scroll wrapper.
      if (table.closest('[data-p74-legal-content], .p7-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'p7-table-scroll';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', '表（横にスクロールできます）');
      table.parentNode.insertBefore(wrap, table); wrap.appendChild(table);
    });
    // Native review HTML may be populated asynchronously by Judge.me.
    var reviewPage = root.querySelector('[data-p7-review-page]');
    if (reviewPage) {
      var note = reviewPage.querySelector('[data-p7-review-load-note]');
      var host = reviewPage.querySelector('.p7-native-reviews');
      var observer = null, timer = null;
      function ready() {
        if (!host) return true;
        var el = host.querySelector('.jdgm-rev, .jdgm-rev-widg__summary, .jdgm-rev-widg__title, .jdgm-all-reviews__body');
        return !!(el && el.getClientRects().length && el.textContent.trim().length > 0);
      }
      function check() {
        if (note && ready()) { note.hidden = true; if(timer) clearTimeout(timer); }
      }
      if (host && note) {
        timer = setTimeout(function () { note.hidden = ready(); }, 15000);
        if ('MutationObserver' in window) { observer = new MutationObserver(check); observer.observe(host, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']}); }
        disposers.push(function () { if(timer) clearTimeout(timer); if(observer) observer.disconnect(); });
      }
      var reload = reviewPage.querySelector('[data-p7-reload]');
      if (reload) {
        var onReload = function () { window.location.reload(); };
        reload.addEventListener('click', onReload);
        disposers.push(function () { reload.removeEventListener('click', onReload); });
      }
    }
    // Preserve the existing cart script. Add keyboard access to its generated quantity buttons.
    function enhanceQuantity() {
      document.querySelectorAll('.js--qty-adjuster, .ajaxifyCart--qty-adjuster').forEach(function (el) {
        if (el.dataset.p7Keyboard === 'true') return;
        el.dataset.p7Keyboard = 'true'; el.tabIndex = 0; el.setAttribute('role', 'button');
        el.setAttribute('aria-label', /minus/.test(el.className) ? '数量を減らす' : '数量を増やす');
        el.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); el.click(); }
        });
      });
    }
    enhanceQuantity();
    // Original cart markup is appended outside #pk6. Observe only additions, never its values.
    var quantityObserver = new MutationObserver(function (entries) {
      if (entries.some(function (entry) { return entry.addedNodes.length > 0; })) enhanceQuantity();
    });
    quantityObserver.observe(document.body, {childList: true, subtree: true});
    disposers.push(function () { quantityObserver.disconnect(); });
  }
  function start() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', function () { var root = document.getElementById('pk6'); if (root) { if(root.__p7Dispose) root.__p7Dispose(); init(document); } });
}());
